import { Base } from '@studiometa/js-toolkit';

/**
 * ArchivesGallerySwitcher class.
 */
export default class ArchivesGallerySwitcher extends Base {
  /**
   * Config.
   */
  static config = {
    name: 'ArchivesGallerySwitcher',
    options: {
      mode: {
        type: String,
        default: 'grid',
      },
    },
  };

  /**
   * Get wrapper.
   * @returns {ArchivesGallery} ArchivesGallery instance.
   */
  get wrapper() {
    return this.$parent;
  }

  /**
   * Mounted.
   * @returns {void}
   */
  mounted() {
    this.wrapper.$on('mode', ({ detail }) => {
      const [mode] = detail;
      if (mode === this.$options.mode) {
        this.$el.classList.add('is-active');
        this.$el.setAttribute('disabled', '');
      } else {
        this.$el.classList.remove('is-active');
        this.$el.removeAttribute('disabled');
      }
    });
    if (this.wrapper.$options.mode === this.$options.mode) {
      this.$el.classList.add('is-active');
      this.$el.setAttribute('disabled', '');
    } else {
      this.$el.classList.remove('is-active');
      this.$el.removeAttribute('disabled');
    }
  }

  /**
   * Click.
   * @returns {void}
   */
  onClick() {
    this.wrapper.mode = this.$options.mode;
  }
}
